import React, { useState, useEffect } from "react";
import AppBar from '../../../components/app_bar.js'
import BottomNavBar from "../../../components/bottom_nav_bar.js";
import Background from "../../../components/background.js";
import { useNotification } from "../../../components/NotificationProvider";
import WheelOfFortune from '../../../components/spin.js'
import '../style/spin.css'

function SpinPage() {
  const { addNotification } = useNotification();

  const [leaderboardData, setLeaderboardData] = useState([]);
  const [notificationVisible, setNotificationVisible] = useState(false);

  const copyReferral = () => {

  };

  useEffect(() => {

  }, []);


  return <>
    <AppBar />
    <BottomNavBar />
    <Background />
    <div className="spinner-wrapper">
      <WheelOfFortune />
    </div>
  </>;
}

export default SpinPage;